function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

function lmsUrl() {
  return process.env.REACT_APP_API_LMS_URL;
}

export function apiV2UserLoanOfferUrl(userId, loanOfferId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/loan_offers/${loanOfferId}`;
}
export function chooseOption(userId, loanOfferId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/loan_offers/${loanOfferId}/choose_option`;
}

export function accept(userId, loanOfferId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/loan_offers/${loanOfferId}/accept`;
}

export function confirm(userId){
  return `${apiBaseUrl()}/api/v2/users/${userId}/loan_offers`
}

export function amortizingLoanPlanSchedulesUrl(leadId, uuid) {
  return `${lmsUrl()}/customers/${leadId}/payment_schedules/${uuid}`;
}

export function createAmortizingLoanPlanSchedulesUrl(leadId) {
  return `${lmsUrl()}/customers/${leadId}/payment_schedules`;
}

export function calculatePaymentSchedulesUrl(leadId) {
  return `${lmsUrl()}/customers/${leadId}/payment_schedules/calculate`;
}



// WEBPACK FOOTER //
// ./src/features/loans/loanOfferApiUrls.js